import { EditorContent as TiptapEditorContent, useCurrentEditor } from "@tiptap/react";
import type { ComponentProps } from "react";

import { cn } from "../../utils";

export interface EditorContentProps extends Partial<ComponentProps<typeof TiptapEditorContent>> {
  className?: string;
}

export const EditorContent = ({ className, ...props }: EditorContentProps) => {
  const { editor } = useCurrentEditor();

  return <TiptapEditorContent {...props} editor={editor} className={cn("flex flex-col", className)} />;
};
